import css from './share-button.css'

export default function () {
    return `<div class="${css.share}" onclick="toggleShareMenu()" data-haslabel>
        </div>`
}
